import { useState } from 'react';
import { Button, Card, Group, Modal, Stack, Stepper, Text, Title } from '@mantine/core';
import {
  IconCalendarEvent,
  IconGridDots,
  IconMapPin,
  IconSparkles,
  IconWand,
} from '@tabler/icons-react';
import { tokens } from '../ui/tokens.ts';

interface Props {
  readonly opened: boolean;
  readonly onClose: () => void;
}

const STEPS = [
  {
    title: '歡迎使用訂位台',
    body: '把今天的所有預約、客人到場、格子使用狀況，一頁看完。再也不用翻紙本訂位本～',
    icon: IconSparkles,
  },
  {
    title: '今日預約一眼看',
    body: '左邊是今天所有訂位的卡片，時間、人數、狀態都寫得清清楚楚，系統不會露出 UUID 之類的技術細節。',
    icon: IconCalendarEvent,
  },
  {
    title: '格子狀態即時更新',
    body: '右邊是跳跳方塊格子的即時使用狀況，哪幾格有人、哪幾格空閒，一目瞭然。',
    icon: IconGridDots,
  },
  {
    title: '分配格子超簡單',
    body: '新進預約顯示「💭 待安排」。點一下「分配格子」，系統會自動挑好幾個候選段，按一下就完成了。',
    icon: IconMapPin,
  },
  {
    title: '所有規則 API 都驗過',
    body: '場次時長、人數上下限、提前訂位、衝突時段，系統都會在送出時就擋下來，員工不用靠腦袋記規則。',
    icon: IconWand,
  },
];

export function TourModal({ opened, onClose }: Props) {
  const [active, setActive] = useState(0);
  const lastStep = active === STEPS.length - 1;
  const step = STEPS[active]!;
  const Icon = step.icon;

  function close() {
    setActive(0);
    onClose();
  }

  return (
    <Modal
      opened={opened}
      onClose={close}
      size="lg"
      centered
      radius="xl"
      padding="xl"
      title={
        <Title order={4} c="navy.7">
          體驗導覽
        </Title>
      }
    >
      <Stack gap="lg">
        <Stepper
          active={active}
          onStepClick={setActive}
          size="xs"
          allowNextStepsSelect
          color={tokens.color.mantine['primary']}
        >
          {STEPS.map((s) => (
            <Stepper.Step key={s.title} label={s.title} />
          ))}
        </Stepper>

        <Card
          radius="xl"
          padding="xl"
          style={{
            background: tokens.gradient.tourCard,
          }}
        >
          <Stack gap="md" align="center">
            <Icon size={48} stroke={1.4} color={tokens.color.primary} />
            <Title order={3} ta="center" c="navy.8">
              {step.title}
            </Title>
            <Text ta="center" c="dimmed" size="md" maw={520} lh={1.8}>
              {step.body}
            </Text>
          </Stack>
        </Card>

        <Group justify="space-between">
          <Button
            variant="subtle"
            color={tokens.color.mantine['neutral']}
            disabled={active === 0}
            onClick={() => setActive((a) => Math.max(0, a - 1))}
          >
            上一步
          </Button>
          {lastStep ? (
            <Button color="navy" onClick={close}>
              開始使用 🎉
            </Button>
          ) : (
            <Button color="navy" onClick={() => setActive((a) => a + 1)}>
              下一步
            </Button>
          )}
        </Group>
      </Stack>
    </Modal>
  );
}
